<template>
  <div class="email">
    <div class="form-item field-email">
      <label for="email">电子邮箱</label>
      <input
        type="text"
        name="email"
        placeholder="激活码将发送至您输入的邮箱"
        v-model="form.email"
      />
      <div v-if="rules.email" class="error">{{rules.email}}</div>
    </div>
    <div class="form-item field-matches-code">
      <label for="matches-code">机器码</label>
      <input
        type="text"
        name="matches-code"
        placeholder="点击软件右上角“激活正式版”，显示机器码"
        v-model="form.machine_id"
      />
      <div v-if="rules.machine_id" class="error">{{rules.machine_id}}</div>
    </div>
    <button class="btn-next" @click="onSubmit">下一步</button>
    <!-- <div class="activation-tips">复制激活码到软件内激活</div>
    <div class="activation-tips">
      保存到本地：将以txt格式保存至桌面，文件名为“小咪隐藏空间激活码”
    </div> -->
  </div>
</template>

<script>
import {apiGetActivationCode, apiSearchMachine, apiPayCode, apiPayPoll} from '@/utils/api/index.js'

export default {
  data: () => ({
    form: {
      email: '',
      machine_id: '',
      channel:'',
    },
    rules: {
      email: '',
      machine_id: '',
    }
  }),
  methods: {
    async getQrCode() {
      const { data: response } = await apiPayCode({ ...this.form, pay_type: 1, })
      // if (response.success) {
      //   const data = response.data
      //   this.qrcode = `data:image;base64,${
      //     data.wx_pay_code || data.ali_pay_code
      //   }`
      //   this.price = data.price * 0.01
      //   this.order_no = data.order_no
      //   this.onLoopQuery()
      // } else {
      //   alert(response.msg)
      // }
      return response.success ? null : response.msg;
    },
    async onSubmit() {
      this.rules.email = !this.form.email ?  '电子邮箱不能为空' : !/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.form.email) ? '请填写正确的邮箱地址' : null;
      this.rules.machine_id = !this.form.machine_id ? '机器码不能为空' : null
      if (!this.rules.email && !this.rules.machine_id) {
        const error = await this.getQrCode();
        if (error) return alert(error)
        this.$router.push({path: '/purchase/qrcode', query: {email: this.form.email, machine_id: this.form.machine_id,channel:this.form.channel}})
      }
    },
  },
  mounted() {
    this.form.machine_id = this.$route.query.code
    this.form.channel = this.$route.query.channel
  },
}
</script>

<style lang='scss' scoped>
.error {
  position: absolute;
  bottom: -24px;
  font-size: 12px;
  color: #ff578e;
}
.email {
  .form-item {
    position: relative;
    display: flex;
    flex-direction: column;
    label {
      font-size: 18px;
      margin-bottom: 20px;
      &::before {
        content: '*';
        display: inline-block;
        color: #ff578e;
      }
    }
    input {
      width: 380px;
      height: 36px;
      padding: 0 10px;
      border: 1px solid #263737;
      border-radius: 8px;

      &::placeholder {
        font-size: 14px;
      }
    }
  }
  .field-email {
    display: flex;
    margin-bottom: 34px;
  }
  .field-matches-code {
    margin-bottom: 46px;
  }
  button {
    width: 190px;
    height: 50px;
    font-size: 20px;
    font-weight: bold;
    color: white;
    border: none;
    background-color: transparent;
    cursor: pointer;
    background-image: url('../../../assets/image/btn-next.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    &:hover {
      background-image: url('../../../assets/image/btn-next-active.png');
    }
  }
}
</style>
